import React from 'react';
import {
  StyleSheet, View, Image, Pressable,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import PropTypes from 'prop-types';

const apmLogo = require('../assets/images/LOGOAPMWHITE.png');

function HeaderBackButton(props) {
  const { style, navigation } = props;

  return (
    <View style={[styles.container, style]}>
      <View style={styles.leftIconButtonRow}>
        <Pressable style={styles.leftIconButton} onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons
            name="keyboard-backspace"
            style={styles.leftIcon}
          />
        </Pressable>
        <View style={styles.textWrapperStack}>
          <View style={styles.textWrapper} />
          <Image
            source={apmLogo}
            resizeMode="contain"
            style={styles.image}
          />
        </View>
      </View>
      <View style={styles.leftIconButtonRowFiller} />
      <Pressable style={styles.rightIconButton}>
        <MaterialCommunityIcons
          name="dots-vertical"
          style={styles.rightIcon}
        />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'black',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 4,
    justifyContent: 'space-between',
    shadowColor: 'white',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.2,
    elevation: 3,
  },
  leftIconButton: {
    padding: 11,
    marginTop: 22,
  },
  leftIcon: {
    backgroundColor: 'transparent',
    color: 'white',
    fontSize: 24,
  },
  textWrapper: {
    position: 'absolute',
    left: 44,
    bottom: 37,
  },
  image: {
    left: 0,
    width: 119,
    height: 91,
    position: 'absolute',
    top: 0,
  },
  textWrapperStack: {
    width: 119,
    height: 91,
    alignSelf: 'flex-end',
    marginLeft: 1,
  },
  leftIconButtonRow: {
    flexDirection: 'row',
    marginLeft: 5,
    marginTop: -17,
    marginBottom: -18,
  },
  leftIconButtonRowFiller: {
    flex: 1,
    flexDirection: 'row',
  },
  rightIconButton: {
    padding: 11,
    alignItems: 'center',
    marginRight: 5,
    marginTop: 5,
  },
  rightIcon: {
    backgroundColor: 'transparent',
    color: 'white',
    fontSize: 24,
  },
});

HeaderBackButton.defaultProps = {
  style: {},
};

HeaderBackButton.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
};

export default HeaderBackButton;
